// Device fingerprint untuk anti-fraud absensi.
//
// Tujuan: hasilkan ID device yang STABIL per-perangkat (bertahan antar sesi)
// supaya server bisa binding device -> user (device pertama = untrusted,
// admin yang trust). Web tidak bisa baca IMEI/serial, jadi kita kombinasikan:
//   1. UUID acak yang disimpan di localStorage (stabil selama storage tidak dihapus)
//   2. Hash dari sinyal browser (UA, platform, bahasa, resolusi, canvas)
//
// Sinyal #2 jadi fallback/penguat: kalau localStorage dihapus, UUID baru lahir
// TAPI komponen hash device tetap mirip — server tetap bisa lihat polanya.
// Ini best-effort (bukan anti-tamper mutlak), sesuai desain.

const STORAGE_KEY = 'attendance-device-id';

function djb2(str: string): string {
    let hash = 5381;
    for (let i = 0; i < str.length; i++) {
        hash = (hash * 33) ^ str.charCodeAt(i);
    }
    // unsigned + base36 biar pendek & stabil
    return (hash >>> 0).toString(36);
}

/** Sinyal browser yang relatif stabil per-device (bukan per-sesi). */
function collectSignals(): string {
    const parts: string[] = [];
    try {
        const n = navigator;
        parts.push(n.userAgent || '');
        parts.push((n as any).platform || '');
        parts.push((n.languages || [n.language]).join(','));
        parts.push(String((n as any).hardwareConcurrency || ''));
        parts.push(String((n as any).deviceMemory || ''));
        parts.push(String((n as any).maxTouchPoints || ''));
    } catch {}
    try {
        parts.push(`${screen.width}x${screen.height}x${screen.colorDepth}`);
        parts.push(String(window.devicePixelRatio || ''));
    } catch {}
    try {
        parts.push(Intl.DateTimeFormat().resolvedOptions().timeZone || '');
    } catch {}
    try {
        parts.push(canvasFingerprint());
    } catch {}
    return parts.join('|');
}

/** Canvas fingerprint ringan: rendering teks/emoji berbeda per GPU/driver/font. */
function canvasFingerprint(): string {
    const canvas = document.createElement('canvas');
    canvas.width = 220;
    canvas.height = 40;
    const ctx = canvas.getContext('2d');
    if (!ctx) return '';
    ctx.textBaseline = 'top';
    ctx.font = "14px 'Arial'";
    ctx.fillStyle = '#f60';
    ctx.fillRect(10, 1, 62, 20);
    ctx.fillStyle = '#069';
    ctx.fillText('satutim-absensi-7', 2, 15);
    ctx.fillStyle = 'rgba(102, 200, 0, 0.7)';
    ctx.fillText('satutim-absensi-7', 4, 17);
    try {
        return djb2(canvas.toDataURL());
    } catch {
        return '';
    }
}

/**
 * Ambil fingerprint device yang stabil. Bentuk: `<uuidShort>.<signalsHash>`.
 * UUID lahir sekali lalu dipersist; signalsHash dihitung tiap kali (tapi nilainya stabil).
 */
export function getDeviceFingerprint(): string {
    let uid = '';
    try {
        uid = localStorage.getItem(STORAGE_KEY) || '';
    } catch {}

    if (!uid) {
        try {
            uid =
                typeof crypto !== 'undefined' && 'randomUUID' in crypto
                    ? crypto.randomUUID()
                    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
        } catch {
            uid = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
        }
        try {
            localStorage.setItem(STORAGE_KEY, uid);
        } catch {}
    }

    const signalsHash = djb2(collectSignals());
    // uid bisa panjang (UUID) — ambil 12 char pertama biar ringkas tapi tetap unik
    return `${uid.replace(/-/g, '').slice(0, 16)}.${signalsHash}`;
}
